import MenuNames from "../../../constants/Menu/MenuNames.json";
import SubIssueType from "../../../views/SubIssueType";
import SubIssueTypeAction from "../../../views/SubIssueTypeAction";

const LogisticsSupportRoutes = [
  {
    menuName: MenuNames.LOGISTICS_SUPPORT_DASHBOARD,
    path: "/sub-issue-types/create",
    component: SubIssueTypeAction,
    exact: true,
  },
  {
    menuName: MenuNames.LOGISTICS_SUPPORT_DASHBOARD,
    path: "/sub-issue-types/:id/:action",
    component: SubIssueTypeAction,
    exact: true,
  },
  {
    menuName: MenuNames.LOGISTICS_SUPPORT_DASHBOARD,
    path: "/sub-issue-types/:issueId",
    component: SubIssueType,
    exact: true,
  },
  {
    menuName: MenuNames.LOGISTICS_SUPPORT_DASHBOARD,
    path: "/sub-issue-types",
    component: SubIssueType,
    exact: true,
  },
];

export default LogisticsSupportRoutes;